export default __webpack_public_path__ + "static/media/IconDesc_XmasLights.256.37b3120c.png";